// 估价单详情页面
<template>
    <div class="main-center" style="margin-top: 80px;">
        <!--估价单基本信息卡片-->
        <div class="cardBox">
            <div class="cardTitle flex flex-align">
                <img src="../../../assets/image/icon/order1.svg" alt="">
                <span>{{$t('estimateDetails.estimateDetails')}}</span>
            </div>
            <div class="cardBody">
                <div class="flex flex-space-around margin-bottom">
                    <!--发送方代码-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>
                                {{$t('estimateDetails.senderCode')}}
                            </span>
                        </div>
                        <el-input v-model="estimate.senderCode" readonly/>
                    </div>
                    <!--港口/堆场-->
                    <div class="inputName">
                        <el-col :span="7" style="width: 49%">
                            <div class="inputName-title">
                            <span>
                                {{$t('estimateDetails.portCodeAnddepotCode')}}
                            </span>
                            </div>
                            <el-input v-model="estimate.portCode" readonly/>
                        </el-col>
                        <el-col :span="7" style="width: 2%">
                            <el-divider direction="vertical"></el-divider>
                        </el-col>
                        <el-col :span="7" style="width: 49%">
                            <el-input v-model="estimate.depotCode" readonly/>
                        </el-col>
                    </div>
                    <!--代理-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>
                                {{$t('estimateDetails.officeCode')}}
                            </span>
                        </div>
                        <el-input v-model="estimate.officeCode" readonly/>
                    </div>
                    <!--申请日期【不可编辑】-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>
                                {{$t('estimateDetails.applyDate')}}
                            </span>
                        </div>
                        <el-date-picker v-model="estimate.applyDate" type="date" class="dateInput1" placeholder="" readonly/>
                    </div>
                </div>
                <div class="flex flex-space-around margin-bottom">
                    <!--估价单号-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>{{$t('estimateDetails.estimateNo')}}</span>
                        </div>
                        <el-input v-model="estimate.estimateNo" readonly/>
                    </div>
                    <!--箱号/箱型-->
                    <div class="inputName">
                        <el-col :span="7" style="width: 49%">
                            <div class="inputName-title">
                                <span>{{$t('estimateDetails.containerNoAndcontainerType')}}</span>
                            </div>
                            <el-input v-model="estimate.containerNo"
                                      readonly
                                      @input="formatUpper('estimate','containerNo',estimate.containerNo)"/>
                        </el-col>
                        <el-col :span="7" style="width: 2%">
                            <el-divider direction="vertical"></el-divider>
                        </el-col>
                        <el-col :span="7" style="width: 49%">
                            <el-input v-model="estimate.containerType"
                                      readonly
                                      @input="formatUpper('estimate','containerType',estimate.containerType)"/>
                        </el-col>
                    </div>
                    <div class="inputName">
                        <!--维修类型-->
                        <div class="inputName-title">
                            <span>{{$t('estimateDetails.repairType')}}</span>
                        </div>
                        <el-select v-model="estimate.repairType"
                                   placeholder="" disabled>
                            <el-option v-for="item in repairTypeOptions"
                                       :key="item.codeValue" :label="getDisplayValue(item)" :value="item.codeValue">
                                <span style="float: left">{{item.displayValue}}</span>
                            </el-option>
                        </el-select>
                    </div>
                    <!--要求完成日期-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>
                                {{$t('estimateDetails.preFinalDate')}}
                            </span>
                        </div>
                        <el-date-picker v-model="estimate.preFinalDate" type="date" class="dateInput1" placeholder="" readonly/>
                    </div>
                </div>
                <div class="flex flex-space-around margin-bottom">
                    <!--空重状态-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>{{$t('estimateDetails.movement')}}</span>
                        </div>
                        <el-select v-model="estimate.movement"
                                   placeholder=""
                                   disabled>
                            <el-option v-for="item in movementOptions"
                                       :key="item.codeValue" :label="getDisplayValue(item)" :value="item.codeValue">
                                <span style="float: left">{{item.displayValueCn}}</span>
                                <span style="float: right; color: #8492a6; font-size: 13px">{{item.displayValue}}</span>
                            </el-option>
                        </el-select>
                    </div>
                    <!--船名/航次-->
                    <div class="inputName">
                        <el-col :span="7" style="width: 49%">
                            <div class="inputName-title">
                                <span>{{$t('estimateDetails.vesselCodeAndvoyageNo')}}</span>
                            </div>
                            <el-input v-model="estimate.vesselCode"
                                      readonly
                                      @input="formatUpper('estimate','vesselCode',estimate.vesselCode)"/>
                        </el-col>
                        <el-col :span="7" style="width: 2%">
                            <el-divider direction="vertical"></el-divider>
                        </el-col>
                        <el-col :span="7" style="width: 49%">
                            <el-input v-model="estimate.voyageNo"
                                      readonly
                                      @input="formatUpper('estimate','voyageNo',estimate.voyageNo)"/>
                        </el-col>
                    </div>
                    <div class="inputName">
                        <!--提单号-->
                        <div class="inputName-title">
                            <span>{{$t('estimateDetails.blNo')}}</span>
                        </div>
                        <el-input v-model="estimate.blNo"
                                  :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                  clearable :disabled="estimate.repairStatus !== 'Applying'"
                                  @input="formatUpper('estimate','blNo',estimate.blNo)" readonly/>
                    </div>
                    <!--是否收费-->
                    <div class="inputName">
                        <el-checkbox v-model="estimate.recvFlag" disabled>{{$t('estimateDetails.recvFlag')}}</el-checkbox>
                    </div>
                </div>
                <div class="flex flex-space-around margin-bottom">
                    <div class="inputName">
                        <!--币种-->
                        <div class="inputName-title">
                            <span>{{$t('estimateDetails.currency')}}</span>
                        </div>
                        <el-input v-model="estimate.currency"
                                  :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                  readonly
                                  @input="formatUpper('estimate','currency',estimate.currency)"/>
                    </div>
                    <div class="inputName">
                        <!--折扣-->
                        <div class="inputName-title">
                            <span>{{$t('estimateDetails.discount')}}</span>
                        </div>
                        <el-input v-model="estimate.discount"
                                  :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                  readonly
                                  @input="formatUpper('estimate','recvFlag',estimate.recvFlag)"/>
                    </div>
                    <div class="inputName">
                        <el-col :span="7" style="width: 49%">
                            <!--DPP-->
                            <div class="inputName-title">
                                <span>DPP</span>
                            </div>
                            <el-input v-model="estimate.dpp"
                                      :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                      readonly/>
                        </el-col>
                        <el-col :span="7" style="width: 2%">
                            <el-divider direction="vertical"></el-divider>
                        </el-col>
                        <el-col :span="7" style="width: 49%">
                            <el-input v-model="estimate.dppCurrency"
                                      :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                      readonly/>
                        </el-col>
                    </div>
                    <!--维修状态-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>{{$t('estimateDetails.repairStatus')}}</span>
                        </div>
                        <el-select v-model="estimate.repairStatus"
                                   placeholder=""
                                   disabled>
                            <el-option v-for="item in repairStatusOptions"
                                       :key="item.codeValue" :label="getDisplayValue(item)" :value="item.codeValue">
                                <span style="float: left">{{item.displayValueCn}}</span>
                                <span style="float: right; color: #8492a6; font-size: 13px">{{item.displayValue}}</span>
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="flex flex-space-around margin-bottom">
                    <!--生产商-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>{{$t('estimateDetails.manufacture')}}</span>
                        </div>
                        <el-input v-model="estimate.manufacture"
                                  :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                  readonly
                                  @input="formatUpper('estimate','manufacture',estimate.manufacture)"/>
                    </div>
                    <!--租箱日期-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>
                                {{$t('estimateDetails.onhiredDate')}}
                            </span>
                        </div>
                        <el-date-picker v-model="estimate.onhiredDate" type="date" class="dateInput1" placeholder="" readonly/>
                    </div>
                    <!--维修方-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>{{$t('estimateDetails.party')}}</span>
                        </div>
                        <el-select v-model="estimate.party"
                                   placeholder=""
                                   disabled>
                            <el-option v-for="item in partyOptions"
                                       :key="item.codeValue" :label="getDisplayValue(item)" :value="item.codeValue">
                                <span style="float: left">{{item.displayValueCn}}</span>
                                <span style="float: right; color: #8492a6; font-size: 13px">{{item.displayValue}}</span>
                            </el-option>
                        </el-select>
                    </div>
                    <!--最后更新人员-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>{{$t('estimateDetails.updatedByUser')}}</span>
                        </div>
                        <el-input v-model="estimate.updatedByUser"
                                  :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                  disabled
                                  @input="formatUpper('estimate','delName',estimate.delName)"/>
                    </div>
                </div>
                <div class="flex flex-space-around margin-bottom">
                    <!--最后更新时间-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>
                                {{$t('estimateDetails.updatedDtmLoc')}}
                            </span>
                        </div>
                        <el-date-picker v-model="estimate.updatedDtmLoc" type="date" class="dateInput1" placeholder="" disabled/>
                    </div>
                    <!--冷机类型-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>{{$t('estimateDetails.maker')}}</span>
                        </div>
                        <el-input v-model="estimate.maker"
                                  :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                  readonly
                                  @input="formatUpper('estimate','maker',estimate.maker)"/>
                    </div>
                    <!--冷机型号-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>{{$t('estimateDetails.modelNo')}}</span>
                        </div>
                        <el-input v-model="estimate.modelNo"
                                  :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                  readonly
                                  @input="formatUpper('estimate','modelNo',estimate.modelNo)"/>
                    </div>
                    <!--保修期-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>{{$t('estimateDetails.warrantyPeriod')}}</span>
                        </div>
                        <el-input v-model="estimate.warrantyPeriod"
                                  :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                  readonly
                                  @input="formatUpper('estimate','warrantyPeriod',estimate.warrantyPeriod)"/>
                    </div>
                </div>
            </div>
        </div>
        <!--箱体参数信息卡片-->
        <div class="cardBox">
            <div class="cardTitle flex flex-space-between">
                <div>
                    <img src="../../../assets/image/icon/order12.svg" alt="">
                    <span>{{$t('estimateDetails.estBodyMachines.estBodyInfo')}}</span>
                </div>
            </div>
            <div class="cardBody">
                <el-table max-height="600" height="180" :data="tableEstBodys" ref="tableEstBodys" style="width:100%;"
                          :header-cell-style="{background:'#E9E9E9',height:'36px',padding:'0px'}"
                          :row-style="{height:'25px'}"
                          :cell-style="{padding:'0px'}"
                          :empty-text="$t('common.noData')">
                    <el-table-column min-width="60" type="index" :label="$t('estimateDetails.index')" align="center"></el-table-column>
                    <!--构件-->
                    <el-table-column min-width="130" show-overflow-tooltip prop="componentCode"
                                     :label="$t('estimateDetails.estBodyMachines.componentCode')" align="center">
                    </el-table-column>
                    <!--部位-->
                    <el-table-column min-width="130" show-overflow-tooltip prop="repairLocationCode"
                                     :label="$t('estimateDetails.estBodyMachines.repairLocationCode')" align="center">
                    </el-table-column>
                    <!--损坏-->
                    <el-table-column min-width="100" show-overflow-tooltip prop="damageCode"
                                     :label="$t('estimateDetails.estBodyMachines.damageCode')" align="center">
                    </el-table-column>
                    <!--维修-->
                    <el-table-column min-width="100" show-overflow-tooltip prop="repairCode"
                                     :label="$t('estimateDetails.estBodyMachines.repairCode')" align="center"></el-table-column>
                    <!--材料-->
                    <el-table-column min-width="100" show-overflow-tooltip prop="materialCode"
                                     :label="$t('estimateDetails.estBodyMachines.materialCode')" align="center"></el-table-column>
                    <!--长度-->
                    <el-table-column min-width="90" show-overflow-tooltip prop="length"
                                     :label="$t('estimateDetails.estBodyMachines.length')" align="center"></el-table-column>
                    <!--宽度-->
                    <el-table-column min-width="100" show-overflow-tooltip prop="width"
                                     :label="$t('estimateDetails.estBodyMachines.width')" align="center"></el-table-column>
                    <!--数量-->
                    <el-table-column min-width="110" show-overflow-tooltip prop="quantity"
                                     :label="$t('estimateDetails.estBodyMachines.quantity')"
                                     align="center"></el-table-column>
                    <!--人工费率-->
                    <el-table-column min-width="100" show-overflow-tooltip prop="loborRate"
                                     :label="$t('estimateDetails.estBodyMachines.loborRate')" align="center"></el-table-column>
                    <!--工时-->
                    <el-table-column min-width="110" show-overflow-tooltip prop="workHours"
                                     :label="$t('estimateDetails.estBodyMachines.workHours')" align="center"></el-table-column>
                    <!--人工费-->
                    <el-table-column min-width="100" show-overflow-tooltip prop="laborCost"
                                     :label="$t('estimateDetails.estBodyMachines.laborCost')" align="center"></el-table-column>
                    <!--材料费率-->
                    <el-table-column min-width="120" show-overflow-tooltip prop="materialRate"
                                     :label="$t('estimateDetails.estBodyMachines.materialRate')" align="center"></el-table-column>
                    <!--材料费-->
                    <el-table-column min-width="120" show-overflow-tooltip prop="materialCost"
                                     :label="$t('estimateDetails.estBodyMachines.materialCost')" align="center"></el-table-column>
                    <!--申请费用-->
                    <el-table-column min-width="130" show-overflow-tooltip prop="estimateAccount"
                                     :label="$t('estimateDetails.estBodyMachines.estimateAccount')" align="center"></el-table-column>
                    <!--审批费用-->
                    <el-table-column min-width="150" show-overflow-tooltip prop="approveAccount"
                                     :label="$t('estimateDetails.estBodyMachines.approveAccount')" align="center"></el-table-column>
                    <!--收取费用-->
                    <el-table-column min-width="140" show-overflow-tooltip prop="receiveAccount"
                                     :label="$t('estimateDetails.estBodyMachines.receiveAccount')" align="center"></el-table-column>
                  <!--  &lt;!&ndash;操作&ndash;&gt;
                    <el-table-column min-width="100" show-overflow-tooltip
                                     :label="$t('bookingSpace.container.operation')" align="center">
                        <template slot-scope="scope">
                            <img src="../../../assets/image/icon/del1.svg" alt=""
                                 @click="removeContainerTableData(scope.row,scope.$index)">
                        </template>
                    </el-table-column>-->
                </el-table>
            </div>
            <!--冷机参数信息卡片-->
            <div class="cardTitle flex flex-space-between" style="margin-top: 15px">
                <div>
                    <img src="../../../assets/image/icon/order12.svg" alt="">
                    <span>{{$t('estimateDetails.estBodyMachines.estBodyMachineInfo')}}</span>
                </div>
            </div>
            <div class="cardBody">
                <el-table max-height="600" height="180" :data="tableEstMachines" ref="tableEstMachines" style="width:100%;"
                          :header-cell-style="{background:'#E9E9E9',height:'36px',padding:'0px'}"
                          :row-style="{height:'25px'}"
                          :cell-style="{padding:'0px'}"
                          :empty-text="$t('common.noData')">
                    <el-table-column min-width="60" type="index" :label="$t('estimateDetails.index')" align="center"></el-table-column>
                    <!--构件-->
                    <el-table-column min-width="130" show-overflow-tooltip prop="componentCode"
                                     :label="$t('estimateDetails.estBodyMachines.componentCode')" align="center">
                    </el-table-column>
                    <!--部位-->
                    <el-table-column min-width="130" show-overflow-tooltip prop="repairLocationCode"
                                     :label="$t('estimateDetails.estBodyMachines.repairLocationCode')" align="center">
                    </el-table-column>
                    <!--损坏-->
                    <el-table-column min-width="100" show-overflow-tooltip prop="damageCode"
                                     :label="$t('estimateDetails.estBodyMachines.damageCode')" align="center">
                    </el-table-column>
                    <!--维修-->
                    <el-table-column min-width="100" show-overflow-tooltip prop="repairCode"
                                     :label="$t('estimateDetails.estBodyMachines.repairCode')" align="center"></el-table-column>
                    <!--材料-->
                    <el-table-column min-width="100" show-overflow-tooltip prop="materialCode"
                                     :label="$t('estimateDetails.estBodyMachines.materialCode')" align="center"></el-table-column>
                    <!--冷机配件号-->
                    <el-table-column min-width="90" show-overflow-tooltip prop="partNo"
                                     :label="$t('estimateDetails.estBodyMachines.partNo')" align="center"></el-table-column>
                    <!--数量-->
                    <el-table-column min-width="110" show-overflow-tooltip prop="quantity"
                                     :label="$t('estimateDetails.estBodyMachines.quantity')"
                                     align="center"></el-table-column>
                    <!--人工费率-->
                    <el-table-column min-width="100" show-overflow-tooltip prop="loborRate"
                                     :label="$t('estimateDetails.estBodyMachines.loborRate')" align="center"></el-table-column>
                    <!--工时-->
                    <el-table-column min-width="110" show-overflow-tooltip prop="workHours"
                                     :label="$t('estimateDetails.estBodyMachines.workHours')" align="center"></el-table-column>
                    <!--人工费-->
                    <el-table-column min-width="100" show-overflow-tooltip prop="laborCost"
                                     :label="$t('estimateDetails.estBodyMachines.laborCost')" align="center"></el-table-column>
                    <!--材料费率-->
                    <el-table-column min-width="120" show-overflow-tooltip prop="materialRate"
                                     :label="$t('estimateDetails.estBodyMachines.materialRate')" align="center"></el-table-column>
                    <!--材料费-->
                    <el-table-column min-width="120" show-overflow-tooltip prop="materialCost"
                                     :label="$t('estimateDetails.estBodyMachines.materialCost')" align="center"></el-table-column>
                    <!--申请费用-->
                    <el-table-column min-width="130" show-overflow-tooltip prop="estimateAccount"
                                     :label="$t('estimateDetails.estBodyMachines.estimateAccount')" align="center"></el-table-column>
                    <!--审批费用-->
                    <el-table-column min-width="150" show-overflow-tooltip prop="approveAccount"
                                     :label="$t('estimateDetails.estBodyMachines.approveAccount')" align="center"></el-table-column>
                    <!--收取费用-->
                    <el-table-column min-width="140" show-overflow-tooltip prop="receiveAccount"
                                     :label="$t('estimateDetails.estBodyMachines.receiveAccount')" align="center"></el-table-column>
                    <!--操作
                    <el-table-column min-width="100" show-overflow-tooltip
                                     :label="$t('bookingSpace.container.operation')" align="center">
                        <template slot-scope="scope">
                            <img src="../../../assets/image/icon/del1.svg" alt=""
                                 @click="removeContainerTableData(scope.row,scope.$index)">
                        </template>
                    </el-table-column>-->
                </el-table>
                <div class="flex flex-space-around">
                    <!--费用合计信息-->
                    <ul class="flex">
                        <!--总工费-->
                        <li class="flex flex-align">
                            <div class="inputName">
                                <div class="inputName-title">
                                    <span>{{$t('estimateDetails.labTotal')}}</span>
                                </div>
                                <el-input v-model="estimate.labTotal" disabled/>
                            </div>
                        </li>
                        <!--总材料费-->
                        <li class="flex flex-align">
                            <div class="inputName">
                                <div class="inputName-title">
                                    <span>{{$t('estimateDetails.matTotal')}}</span>
                                </div>
                                <el-input v-model="estimate.matTotal" disabled/>
                            </div>
                        </li>
                        <!--申请总费-->
                        <li class="flex flex-align">
                            <div class="inputName">
                                <div class="inputName-title">
                                    <span>{{$t('estimateDetails.applyTotal')}}</span>
                                </div>
                                <el-input v-model="estimate.applyTotal" disabled/>
                            </div>
                        </li>
                        <!--审批总费-->
                        <li class="flex flex-align">
                            <div class="inputName">
                                <div class="inputName-title">
                                    <span>{{$t('estimateDetails.approveTotal')}}</span>
                                </div>
                                <el-input v-model="estimate.approveTotal" disabled/>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <!--申请备注信息-->
        <div class="cardBox">
            <div class="cardTitle flex flex-align">
                <img src="../../../assets/image/icon/order11.svg" alt="">
                <span>{{$t('estimateDetails.applyRemark')}}</span>
            </div>
            <div class="cardBody">
                <div class="flex flex-space-around" style="height: 70px">
                    <div style="width:33%;margin-top:2px;">
                        <!--申请备注-->
                        <div class="inputName">
                            <div class="inputName-title">
                                <span>{{$t('estimateDetails.applyRemark')}}</span>
                            </div>
                            <el-input v-model="estimate.applyRemark" type="textarea" :rows="2"
                                      show-word-limit
                                      :placeholder="getPlaceHolder($t('common.pleaseEnterContent'))"
                                      @input="formatUpper('estimate','applyRemark',estimate.applyRemark)"/>
                        </div>
                    </div>
                    <div style="width:33%;margin-top:2px">
                        <!--审批备注-->
                        <div class="inputName ">
                            <div class="inputName-title">
                                <span>{{$t('estimateDetails.approveRemark')}}</span>
                            </div>
                            <el-input v-model="estimate.approveRemark" type="textarea" :rows="2"
                                      show-word-limit
                                      :placeholder="getPlaceHolder($t('common.pleaseEnterContent'))"
                                      disabled/>
                        </div>
                    </div>
                    <div style="width:33%;margin-top:2px">
                        <!--收费备注-->
                        <div class="inputName ">
                            <div class="inputName-title">
                                <span>{{$t('estimateDetails.receiveRemark')}}</span>
                            </div>
                            <el-input v-model="estimate.receiveRemark" type="textarea" :rows="2"
                                      show-word-limit
                                      :placeholder="getPlaceHolder($t('common.pleaseEnterContent'))"
                                      @input="formatUpper('estimate','receiveRemark',estimate.receiveRemark)"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--箱图片-->
        <div class="cardBox">
            <div class="cardBody">
                <el-row :gutter="20">
                    <!--箱损图片信息表格-->
                        <el-col style="width: 65%;margin-bottom: 10px">
                        <div class="cardTitle flex flex-space-between">
                            <div>
                                <img src="../../../assets/image/icon/order11.svg" alt="">
                                <span>{{$t('estimateDetails.estContainerPic.estContainerPicInfo')}}</span>
                            </div>
                            <div class="flex flex-space-between">
                                <el-button icon="el-icon-delete-solid" plain size="mini"
                                    @click="handleDamagePicBatchDelete">
                                    {{$t('common.deleteButton')}}
                                </el-button>
                                <el-button icon="el-icon-upload" type="primary" size="mini"
                                    @click="damagePicturesUpload">
                                    {{$t('estimateDetails.estimatePicturesBatchUpload')}}
                                </el-button>
                                <!--<el-button icon="el-icon-delete-solid" type="primary" size="mini"
                                    @click="handlePicBatchDelete">
                                    批量删除
                                </el-button>-->
                            </div>
                        </div>
                        <div class="cardBody">
                            <el-table :data="tableEstContainerPicInfo" ref="tableEstContainerPicInfo" class="show_table"
                                      style="width:100%;margin-top:5px"
                                      height="140" max-height="140" highlight-current-row
                                      :header-cell-style="{background:'#E9E9E9',height:'30px',padding:0}"

                                      :row-style="{height:'20px'}" :cell-style="{padding:'0px'}"
                                      :empty-text="$t('common.noData')"
                                      @current-change="handleDamagePicCurrentChange"
                                      @selection-change="handleDamagePicChecked">
                                <el-table-column
                                        type="selection"
                                        width="45"/>
                                <!--序号-->
                                <el-table-column min-width="50" show-overflow-tooltip type="index"
                                                 :label="$t('estimateDetails.estContainerPic.index')" align="center"/>
<!--                                &lt;!&ndash;图片类型&ndash;&gt;-->
<!--                                <el-table-column min-width="100" show-overflow-tooltip prop="isRepairCompleted"-->
<!--                                                 :label="$t('estimateDetails.estContainerPic.isRepairCompleted')"-->
<!--                                                 align="center"-->
<!--                                                 :filters="[{ text: $t('estimateDetails.estContainerPic.complete'), value: true },-->
<!--                                                            { text: $t('estimateDetails.estContainerPic.damage'), value: false }]"-->
<!--                                                 :filter-method="filterTag"-->
<!--                                                 filter-placement="bottom-end">-->
<!--                                    <template slot-scope="scope">-->
<!--                                        <el-tag size="mini"-->
<!--                                                :type="scope.row.isRepairCompleted ? 'success' : 'primary'"-->
<!--                                                disable-transitions>{{scope.row.isRepairCompleted ? $t('estimateDetails.estContainerPic.complete') : $t('estimateDetails.estContainerPic.damage')}}</el-tag>-->
<!--                                    </template>-->
<!--                                </el-table-column>-->
                                <!--文件名-->
                                <el-table-column min-width="180" show-overflow-tooltip prop="fileName"
                                                 :label="$t('estimateDetails.estContainerPic.fileName')" sortable
                                                 align="center"/>
                                <!--上传日期-->
                                <el-table-column min-width="160" show-overflow-tooltip prop="createdDtmLoc"
                                                 :label="$t('estimateDetails.estContainerPic.createdDtmLoc')" sortable
                                                 align="center"/>
                                <!--备注-->
                                <el-table-column min-width="180" show-overflow-tooltip prop="remark"
                                                 :label="$t('estimateDetails.estContainerPic.remark')"
                                                 align="center"/>
                                <!--<el-table-column min-width="60" :label="$t('common.operation')">
                                    <template slot-scope="scope">
                                        <el-button
                                                size="mini"
                                                type="text"
                                                icon="el-icon-delete-solid"
                                                @click="handleDamagePicDelete(scope.$index, scope.row)"/>
                                    </template>
                                </el-table-column>-->
                            </el-table>
                        </div>
                        <!--修妥图片信息表格-->
                        <div class="cardTitle2 flex flex-space-between">
                            <div>
                                <img src="../../../assets/image/icon/order11.svg" alt="">
                                <span>{{$t('estimateDetails.estContainerPic.estCompleteContainerPicInfo')}}</span>
                            </div>
                            <div class="flex flex-space-between">
                                <el-button icon="el-icon-delete-solid" plain size="mini"
                                           @click="handleCompletePicBatchDelete">
                                    {{$t('common.deleteButton')}}
                                </el-button>
                                <el-button icon="el-icon-upload" type="success" size="mini"
                                           @click="completePicturesUpload">
                                    {{$t('estimateDetails.completedPicturesBatchUpload')}}
                                </el-button>
                                <!--<el-button icon="el-icon-delete-solid" type="primary" size="mini"
                                    @click="handlePicBatchDelete">
                                    批量删除
                                </el-button>-->
                            </div>
                        </div>
                        <div class="cardBody">
                            <el-table :data="tableEstCompleteContainerPicInfo" ref="tableEstCompleteContainerPicInfo" class="show_table"
                                      style="width:100%;margin-top:5px"
                                      height="140" max-height="140" highlight-current-row
                                      :header-cell-style="{background:'#E9E9E9',height:'30px',padding:0}"
                                      :row-style="{height:'20px'}" :cell-style="{padding:'0px'}"
                                      :empty-text="$t('common.noData')"
                                      @current-change="handleCompletePicCurrentChange"
                                      @selection-change="handleCompletePicChecked">
                                <el-table-column
                                        type="selection"
                                        width="45"/>
                                <!--序号-->
                                <el-table-column min-width="50" show-overflow-tooltip type="index"
                                                 :label="$t('estimateDetails.estContainerPic.index')" align="center"/>
<!--                                &lt;!&ndash;图片类型&ndash;&gt;-->
<!--                                <el-table-column min-width="100" show-overflow-tooltip prop="isRepairCompleted"-->
<!--                                                 :label="$t('estimateDetails.estContainerPic.isRepairCompleted')"-->
<!--                                                 align="center"-->
<!--                                                 :filters="[{ text: $t('estimateDetails.estContainerPic.complete'), value: true },-->
<!--                                                            { text: $t('estimateDetails.estContainerPic.damage'), value: false }]"-->
<!--                                                 :filter-method="filterTag"-->
<!--                                                 filter-placement="bottom-end">-->
<!--                                    <template slot-scope="scope">-->
<!--                                        <el-tag size="mini"-->
<!--                                                :type="scope.row.isRepairCompleted ? 'success' : 'primary'"-->
<!--                                                disable-transitions>{{scope.row.isRepairCompleted ? $t('estimateDetails.estContainerPic.complete') : $t('estimateDetails.estContainerPic.damage')}}</el-tag>-->
<!--                                    </template>-->
<!--                                </el-table-column>-->
                                <!--文件名-->
                                <el-table-column min-width="180" show-overflow-tooltip prop="fileName"
                                                 :label="$t('estimateDetails.estContainerPic.fileName')" sortable
                                                 align="center"/>
                                <!--上传日期-->
                                <el-table-column min-width="160" show-overflow-tooltip prop="createdDtmLoc"
                                                 :label="$t('estimateDetails.estContainerPic.createdDtmLoc')" sortable
                                                 align="center"/>
                                <!--备注-->
                                <el-table-column min-width="180" show-overflow-tooltip prop="remark"
                                                 :label="$t('estimateDetails.estContainerPic.remark')"
                                                 align="center"/>
                                <!--<el-table-column min-width="60" :label="$t('common.operation')">
                                    <template slot-scope="scope">
                                        <el-button
                                                size="mini"
                                                type="text"
                                                icon="el-icon-delete-solid"
                                                @click="handlePicDelete(scope.$index, scope.row)"/>
                                    </template>
                                </el-table-column>-->
                            </el-table>
                        </div>
                    </el-col>
                    <!--箱图片缩略图-->
                    <el-col style="width: 35%;">
                        <div class="cardTitle flex flex-align">
                            <img src="../../../assets/image/icon/order12.svg" alt="">
                            <span>{{$t('estimateDetails.estContainerPic.picPreview')}}</span>
                            <span style="font-size: 12px;color: #999999">{{getFirstFileName}}</span>
                        </div>
                        <div class="cardBody">
                            <div class="demo-image__error">
                                <el-image
                                        style="width: 400px;height: 300px" fit="contain"
                                        :src="getFirstFileUrl"
                                        :preview-src-list="getFileUrlList">
                                    <div slot="error" class="el-image__error">
                                        <i class="el-icon-picture">{{$t('estimateDetails.estContainerPic.tips')}}</i>
                                    </div>
                                </el-image>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>

        <!--第三方收费信息卡片-->
        <div class="cardBox">
            <div class="cardTitle flex flex-space-between">
                <div>
                    <img src="../../../assets/image/icon/order12.svg" alt="">
                    <span>{{$t('estimateDetails.estimateCustomerCharge.estimateCustomerChargeInfo')}}</span>
                </div>
            </div>
            <div class="cardBody">
                <el-table max-height="600" height="150px" :data="tableEstimateCustomerChargeInfo" style="width:100%;"
                          :header-cell-style="{background:'#E9E9E9',height:'36px',padding:'0px'}"
                          :row-style="{height:'40px'}"
                          :cell-style="{padding:'0px'}"
                          :empty-text="$t('common.noData')">
                    <el-table-column min-width="60" type="index" :label="$t('estimateDetails.estimateCustomerCharge.index')" align="center"></el-table-column>
                    <!--收费日期-->
                    <el-table-column min-width="150" show-overflow-tooltip prop="receiveDate"
                                     :label="$t('estimateDetails.estimateCustomerCharge.receiveDate')" align="center">
                    </el-table-column>
                    <!--收费金额-->
                    <el-table-column min-width="150" show-overflow-tooltip prop="receiveAmount"
                                     :label="$t('estimateDetails.estimateCustomerCharge.receiveAmount')" align="center">
                    </el-table-column>
                    <!--币种-->
                    <el-table-column min-width="90" show-overflow-tooltip prop="currency"
                                     :label="$t('estimateDetails.estimateCustomerCharge.currency')" align="center">
                    </el-table-column>
                    <!--审批金额-->
                    <el-table-column min-width="150" show-overflow-tooltip prop="approverAmount"
                                     :label="$t('estimateDetails.estimateCustomerCharge.approverAmount')" align="center"></el-table-column>
                    <!--审批时间-->
                    <el-table-column min-width="150" show-overflow-tooltip prop="approverDate"
                                     :label="$t('estimateDetails.estimateCustomerCharge.approverDate')" align="center"></el-table-column>
                    <!--审批人-->
                    <el-table-column min-width="100" show-overflow-tooltip prop="approver"
                                     :label="$t('estimateDetails.estimateCustomerCharge.approver')" align="center"></el-table-column>
                    <!--退费日期-->
                    <el-table-column min-width="150" show-overflow-tooltip prop="refundDate"
                                     :label="$t('estimateDetails.estimateCustomerCharge.refundDate')" align="center"></el-table-column>
                    <!--退费金额-->
                    <el-table-column min-width="150" show-overflow-tooltip prop="refundAmount"
                                     :label="$t('estimateDetails.estimateCustomerCharge.refundAmount')"
                                     align="center"></el-table-column>
                    <!--收退费说明-->
                    <el-table-column min-width="150" show-overflow-tooltip prop="remark"
                                     :label="$t('estimateDetails.estimateCustomerCharge.remark')" align="center"></el-table-column>
                </el-table>
            </div>
        </div>

        <!--箱损图片上传弹框-->
        <el-dialog
                :visible.sync="containerDamagePictureUploadShow"
                width="830px" top="5%">
            <div slot="title" class="flex flex-align">
                <i class="el-icon-upload">箱损图片上传</i>
            </div>
            <div class="el-upload__tip" style="color:#BC1920;margin-top: 10px;margin-bottom: 10px">【注】图片上传仅支持 *.jpg,*.jpeg*.png,*.bmp,*.gif 格式的图片文件，支持40个文件一次上传，单个文件大小不得超过5MB</div>
            <div class="el-upload__tip" style="color:#BC1920;margin-top: 10px;margin-bottom: 10px">{{$t('estimate.uploadTips')}}</div>
            <el-upload
                    class="my-upload-demo"
                    drag multiple
                    ref="containerDamagePictureUpload"
                    accept=".jpg,.jpeg,.png,.bmp"
                    action=""
                    :http-request="handleDamgePictureUpload"
                    :on-success="uploadSuccess"
                    :file-list="fileList"
                    list-type="picture"
                    :auto-upload="false">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">{{$t('common.dragUploadTips1')}}<em>{{$t('common.dragUploadTips2')}}</em></div>
            </el-upload>
            <el-button style="margin-left: 10px;margin-top: 10px" size="small" type="warning" icon="el-icon-refresh"
                       @click="resetFileList">{{$t('common.resetButton')}}</el-button>
            <el-button style="margin-left: 10px;margin-top: 10px" size="small" type="success" icon="el-icon-upload2"
                       @click="uploadDamageFiles">{{$t('estimate.uploadFiles')}}</el-button>
        </el-dialog>

        <!--修妥图片上传弹框-->
        <el-dialog
                :visible.sync="containerCompletePictureUploadShow"
                width="830px" top="5%">
            <div slot="title" class="flex flex-align">
                <i class="el-icon-upload">修妥图片上传</i>
            </div>
            <div class="el-upload__tip" style="color:#BC1920;margin-top: 10px;margin-bottom: 10px">【注】图片上传仅支持 *.jpg,*.jpeg*.png,*.bmp,*.gif 格式的图片文件，支持40个文件一次上传，单个文件大小不得超过5MB</div>
            <div class="el-upload__tip" style="color:#BC1920;margin-top: 10px;margin-bottom: 10px">{{$t('estimate.uploadTips')}}</div>
            <el-upload
                    class="my-upload-demo"
                    drag multiple
                    ref="containerCompletePictureUpload"
                    accept=".jpg,.jpeg,.png,.bmp"
                    action=""
                    :http-request="handleCompletePictureUpload"
                    :on-success="uploadSuccess"
                    :file-list="fileList"
                    list-type="picture"
                    :auto-upload="false">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">{{$t('common.dragUploadTips1')}}<em>{{$t('common.dragUploadTips2')}}</em></div>
            </el-upload>
            <el-button style="margin-left: 10px;margin-top: 10px" size="small" type="warning" icon="el-icon-refresh"
                       @click="resetFileList">{{$t('common.resetButton')}}</el-button>
            <el-button style="margin-left: 10px;margin-top: 10px" size="small" type="success" icon="el-icon-upload2"
                       @click="uploadCompleteFiles">{{$t('estimate.uploadFiles')}}</el-button>
        </el-dialog>

        <!--底部按钮组-->
        <div class="footer-group">
            <!--保存按钮-->
            <el-button class="save-green-button" type="success"
                       @click="returnSave" :disabled="getSaveButtonStatus">
                {{$t('common.saveBtn')}}
            </el-button>
            <!--删除按钮-->
            <el-button type="primary" class="return-button" :disabled="getDeleteButtonStatus"
                       @click="returnDelete">
                {{$t('common.deleteButton')}}
            </el-button>
            <!--返回按钮-->
            <el-button class="return-button" type="info" @click="returnPage">
                {{returnButton}}
            </el-button>
        </div>

        <!--页面底部组件-->
        <div class="footerSpan">
            <span></span>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'lading-details',
        computed: {
            /************************************ 页面按钮国际化信息 ***********************************/
            //返回按钮
            returnButton() {
                return this.$t("common.returnButton");
            },
            getFileUrlList(){
                let ossUrls = [];
                // 获取箱损图片信息
                if(this.tableEstContainerPicInfo != null && this.tableEstContainerPicInfo.length > 0){
                    this.tableEstContainerPicInfo.forEach((item)=>{
                        ossUrls.push(item.ossUrl);
                    })
                }
                // 获取修妥图片信息
                if(this.tableEstCompleteContainerPicInfo != null && this.tableEstCompleteContainerPicInfo.length > 0){
                    this.tableEstCompleteContainerPicInfo.forEach((item)=>{
                        ossUrls.push(item.ossUrl);
                    })
                }
                return ossUrls;
            },
            getFirstFileUrl(){
                let firstUrl = "";
                if(this.tableEstContainerPicInfo != null && this.tableEstContainerPicInfo.length > 0){
                    // 校验有无选中箱损图片行，选中某行则展示该行对应图片，否则展示箱损第一行对应图片
                    if(this.tableEstContainerPicSelection != null){
                        firstUrl = this.tableEstContainerPicSelection.ossUrl;
                    }else{
                        firstUrl = this.tableEstContainerPicInfo[0].ossUrl;
                    }
                }else{
                    return "";
                }
                return firstUrl;
            },
            getFirstFileName(){
                let firstfileName = "";
                if(this.tableEstContainerPicInfo != null && this.tableEstContainerPicInfo.length > 0){
                    // 校验有无选中图片行，选中某行则展示该行对应图片，否则展示第一行对应图片
                    if(this.tableEstContainerPicSelection != null){
                        firstfileName = "("+this.tableEstContainerPicSelection.fileName+")";
                    }else{
                        firstfileName = "("+this.tableEstContainerPicInfo[0].fileName+")";
                    }
                }else{
                    return "";
                }
                return firstfileName;
            },
            // 删除按钮权限控制
            getDeleteButtonStatus(){
                return this.estimate == null || this.estimate.repairStatus !== "Applying"
            },
            // 保存按钮权限控制
            getSaveButtonStatus(){
                return this.estimate == null;
            }
        },
        data() {
            return {
                isSaveClick: false,         // 控制保存按钮点击频率
                repairStatusOptions: [      //维修状态下拉值
                    {codeValue: "Applying", displayValueCn: "申请中", displayValue: "APPLYING"},
                    {codeValue: "Approved", displayValueCn: "已审批", displayValue: "APPROVED"},
                    {codeValue: "Rejected", displayValueCn: "已拒绝", displayValue: "REJECTED"},
                    {codeValue: "Finished", displayValueCn: "修箱完成", displayValue: "REPAIR FINISHED"},
                    {codeValue: "FinishApprove", displayValueCn: "完成审核", displayValue: "FINISH APPROVED"},
                    {codeValue: "FinishReject", displayValueCn: "完成拒绝", displayValue: "FINISH REJECTED"}
                ],
                movementOptions: [          //空重状态
                    {codeValue: "IC", displayValueCn: "随船重箱", displayValue: "IC"},
                    {codeValue: "MM", displayValueCn: "随船空箱", displayValue: "MM"},
                ],
                repairTypeOptions: [        //维修类型
                    {codeValue: "Normal", displayValueCn: "Normal", displayValue: "Normal"},
                    {codeValue: "Off/Hire", displayValueCn: "Off/Hire", displayValue: "Off/Hire"},
                ],
                partyOptions: [
                    {codeValue: 0, displayValueCn: "GMAR", displayValue: "GMAR"},
                    {codeValue: 1, displayValueCn: "客户", displayValue: "Customer"},
                ],
                popover: {
                    packageType: "",
                    packageDesc: "",
                    popTableSelection: [],
                    popTotal: 0,
                    popPageCount: 5,
                    popPageNum: 1,
                    popPageSize: 50,
                },
                estimate: {
                    //估价单号
                    estimateNo: "",
                    //发送方代码
                    senderCode: "",
                    //港口
                    portCode: "",
                    //堆场
                    depotCode: "",
                    //代理
                    officeCode: "",
                    //申请日期
                    applyDate: "",
                    //箱号
                    containerNo: "",
                    //箱型
                    containerType: "",
                    //维修类型
                    repairType: "",
                    // 要求完成日期
                    preFinalDate: "",
                    //空重状态
                    movement: "",
                    //提单号
                    blNo: "",
                    //是否收费
                    recvFlag: "",
                    //币种
                    currency: "",
                    //折扣
                    discount: "",
                    //DPP
                    dpp: "",
                    dppCurrency: "",
                    //生产商
                    manufacture: "",
                    //租箱日期
                    onhiredDate: "",
                    //维修方
                    party: "",
                    //冷机类型
                    maker: "",
                    //冷机型号
                    modelNo: "",
                    //保修期
                    warrantyPeriod: "",
                    //最后更新人员
                    updatedByUser: "",
                    //最后更新时间
                    updatedDtmLoc: "",
                    //申请备注
                    applyRemark: "",
                    //审批备注
                    approveRemark: "",
                    //收费备注
                    receiveRemark: "",
                    //总人工费
                    labTotal: "0.00",
                    //总材料费
                    matTotal: "0.00",
                    //申请总费
                    applyTotal: "0.00",
                    //审核总费
                    approveTotal: "0.00"
                },
                //【箱体参数信息】
                tableEstBodys: [],
                //【冷机参数信息】
                tableEstMachines: [],
                deleteEstContainerPictures: [],     // 待删除箱图片数组
                tableEstContainerPicSelection: null,// 当前选中箱图片行
                //【箱损图片信息】
                tableEstContainerPicInfo: [],       // 箱损图片表格
                tableEstContainerPicChecked: [],    // 箱损图片表格当前勾选图片记录列表
                //【修妥图片信息】
                tableEstCompleteContainerPicInfo: [],       // 箱损图片表格
                tableEstCompleteContainerPicChecked: [],    // 箱损图片表格当前勾选图片记录列表
                //【第三方收费信息】
                tableEstimateCustomerChargeInfo: [],
                firstUrl: "",
                // 总费用
                totalFee: {
                    txtLabTotal: 0,// 总人工费
                    txtMatTotal: 0,// 总材料费
                    txtApplyTotal: 0,// 申请总费
                    txtApproveTotal: 0// 审核总费
                },
                fileList: [],            //待上传箱图片列表
                containerDamagePictureUploadShow: false,// 控制箱损图片上传弹框显示
                containerCompletePictureUploadShow: false,// 控制修妥图片上传弹框显示
                fileImport : new FormData(), // 待上传图片列表
                uploadValidate: true,        // 上传校验通过标志
                percent: 0
            }
        },
        methods: {
            formatImportNumber(number, decimals) {
                let formatNumber = "";
                if(number === ""){
                    return formatNumber;
                }
                //去掉非法字符
                number = (number + '').replace(/[^\d.]/g, '')
                    // 必须保证第一个为数字而不是. 输入第一位为.默认补充0
                    .replace(/^\./g, '0.')
                    // 保证只有出现一个.而没有多个.
                    .replace(/\.{2,}/g, '.')
                    // 保证.只出现一次，而不能出现两次以上
                    .replace('.', '$#$')
                    .replace(/\./g, '')
                    .replace('$#$', '.');
                let strs = number.split('.');
                if (strs.length === 1) {
                    formatNumber = strs[0];
                } else if (strs.length > 1) {
                    if (strs[1].length > decimals) {
                        strs[1] = strs[1].substring(0, decimals);
                    }
                    formatNumber = strs.join('.');
                }
                return formatNumber;
            },
            formatNumber(number, decimals) {
                if (number !== "") {
                    let formatNumber = "";
                    //去掉非法字符
                    number = (number + '').replace(/[^\d.]/g, '')
                    // 必须保证第一个为数字而不是. 输入第一位为.默认补充0
                        .replace(/^\./g, '0.')
                        // 保证只有出现一个.而没有多个.
                        .replace(/\.{2,}/g, '.')
                        // 保证.只出现一次，而不能出现两次以上
                        .replace('.', '$#$')
                        .replace(/\./g, '')
                        .replace('$#$', '.');
                    let strs = number.split('.');
                    if (strs.length === 1) {
                        formatNumber = strs[0];
                    } else if (strs.length > 1) {
                        strs[1] += "00";
                        if (strs[1].length > decimals) {
                            strs[1] = strs[1].substring(0, decimals);
                        }
                        formatNumber = strs.join('.');
                    }
                    return formatNumber;
                }
            },
            /**
             * 箱损图片点击预览
             */
            handleDamagePicCurrentChange(val){
                // 清空修妥图片选中
                this.$refs.tableEstCompleteContainerPicInfo.setCurrentRow();
                this.$refs.tableEstContainerPicInfo.setCurrentRow(val,true);
                this.tableEstContainerPicSelection = val;
            },
            /**
             * 修妥图片点击预览
             */
            handleCompletePicCurrentChange(val){
                // 清空箱损图片选中
                this.$refs.tableEstContainerPicInfo.setCurrentRow();
                this.$refs.tableEstCompleteContainerPicInfo.setCurrentRow(val,true);
                this.tableEstContainerPicSelection = val;
            },
            /**
             * 箱损图片表格勾选事件
             */
            handleDamagePicChecked(val){
                this.tableEstContainerPicChecked = val;
            },
            /**
             * 修妥图片表格勾选事件
             */
            handleCompletePicChecked(val){
                this.tableEstCompleteContainerPicChecked = val;
            },
            getPlaceHolder(defaultValue) {
                // return this.bookingHead.blStatus == 1 ? '' : defaultValue;
            },

            /**
             * 估价单保存方法
             */
            returnSave() {
                if (this.isSaveClick) {
                    return;
                }
                this.isSaveClick = true;
                const condition = this.returnCondition();

                this.axios({
                    method: 'post',
                    url: '/api/equipment/estimatesSave',
                    data: condition,
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(response => {
                    this.responseCode = response.data.backMessage;
                    if (response.data.backCode === "200") {
                        this.showMessage(false, this.responseCode, "success");
                        // 保存成功刷新页面数据
                        this.setFieldValue(response.data.object);
                        this.refreshPage();
                    } else {
                        this.showMessage(false, this.responseCode, "error");
                        if (response.data.backCode === "207"){
                            // 当前未登录，跳转到登录页面
                            this.$router.push({
                                path: '/homePage',
                                query: {redirect: "/estimateDetails"} // 将跳转的路由path作为参数，登录成功后跳转到该路由
                            });
                        }
                    }
                    this.isSaveClick = false;
                }).catch(error => {
                    this.isSaveClick = false;
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            /**
             * 估价单删除
             */
            returnDelete(){
                //删除估价单，将级联删除减免记录，是否确认删除?
                this.$confirm(this.$t('estimateDetails.estimateDeleteConfirm'), this.$t("common.pleaseConfirm"), {
                    distinguishCancelAndClose: true,
                    confirmButtonText: this.$t("common.deleteButton"),
                    cancelButtonText: this.$t("common.cancelButton")
                }).then(() => {
                    let condition = this.returnCondition();
                    this.axios({
                        method: 'post',
                        url: '/api/equipment/estimateDelete',
                        data: condition,
                        headers: {
                            'Accept-language': localStorage.getItem("locale")
                        }
                    }).then(response => {
                        this.responseCode = response.data.backMessage;
                        if (response.data.backCode === "200") {
                            this.showMessage(false, this.responseCode, "success");
                            // 删除成功返回估价单查询页
                            this.returnPage();
                        } else {
                            this.showMessage(false, this.responseCode, "error");
                            // 当前未登录，跳转到登录页面
                            this.$router.push({
                                path: '/homePage',
                                query: {redirect: "/estimateDetails"} // 将跳转的路由path作为参数，登录成功后跳转到该路由
                            });
                        }
                    }).catch(error => {
                        if (error.data) {
                            this.responseCode = error.data.backMessage;
                            this.showMessage(false, this.responseCode, "error");
                        } else {
                            this.showMessage(false, error, "error");
                        }
                    });
                })
            },
            /**
             * 获取当前页面估价单数据 公共方法
             */
            returnCondition() {
                // 【估价单基本信息】
                let estimate = this.estimate;
                estimate.estBodyMachineApprs = [];
                estimate.estContainerPictures = [];

                // 【估价单箱体/冷机信息】
                this.tableEstBodys.forEach((item)=>{
                    estimate.estBodyMachineApprs.push(item);
                });

                this.tableEstMachines.forEach((item)=>{
                    estimate.estBodyMachineApprs.push(item);
                });

                // 【估价单箱图片信息】
                this.tableEstContainerPicInfo.forEach((item)=>{
                    estimate.estContainerPictures.push(item);
                });
                this.tableEstCompleteContainerPicInfo.forEach((item)=>{
                    estimate.estContainerPictures.push(item);
                });
                if (this.deleteEstContainerPictures.length > 0) {
                    this.deleteEstContainerPictures.forEach((deleteItem) => {
                        deleteItem.rowStatus = 8;//设置为待删除状态
                        estimate.estContainerPictures.push(deleteItem);
                    })
                }

                // 【第三方收退费信息】
                let estimateCustomerChargeList = this.tableEstimateCustomerChargeInfo;
                return estimate;
            },
            refreshPage(){
                // 还原按钮控制状态
                this.isSaveClick = false;
                // 清空待删除箱图片数组
                this.deleteEstContainerPictures = [];

                // 清空箱图片当前勾选数组
                this.tableEstContainerPicChecked = [];
                this.tableEstCompleteContainerPicChecked = [];

                // 箱图片默认选中箱损第一行
                if(this.tableEstContainerPicInfo.length > 0){
                    this.$refs.tableEstContainerPicInfo.setCurrentRow(this.tableEstContainerPicInfo[0],true);
                    this.tableEstContainerPicSelection = this.tableEstContainerPicInfo[0];
                }

                // 清空待上传文件列表
                this.fileList = [];
                this.fileImport = new FormData();
            },

            /************************************ 基础数据下拉赋值 ***********************************
             * 公共方法
             */
            getDisplayValue(item) {
                return localStorage.getItem('locale') == 'en' ? item.displayValue : item.displayValueCn;
            },

            /************************************ 页面数据初始化 ************************************/
            initPageInfo() {
                // if (this.$route.params == null) {
                //     return;
                // }
                // if (this.$route.params.estimateInfo == null) {
                //     return;
                // }
                // // 页面数据赋值
                // let estimateInfo = this.$route.params.estimateInfo;
                if(sessionStorage.getItem("PASSING_PARAMETERS") == null){
                    return;
                }
                let estimateInfo = JSON.parse(sessionStorage.getItem("PASSING_PARAMETERS"));
                this.setFieldValue(estimateInfo);
                this.$nextTick(() => {//等待页面渲染好之后再调用，否则获取不到this.refs
                    this.refreshPage();
                });
            },
            setFieldValue(data) {
                // 更新原始数据
                this.oldEstimateInfo = data;

                // 清空页面数据，重新赋值
                this.tableEstBodys = [];
                this.tableEstMachines = [];
                this.tableEstContainerPicInfo = [];
                this.tableEstCompleteContainerPicInfo = [];
                this.tableEstimateCustomerChargeInfo = [];

                let estimateInfo = data[0];
                //【第三方收退费信息】
                if(data.length === 2){
                    this.tableEstimateCustomerChargeInfo = data[1];
                }
                this.estimate = estimateInfo;
                this.estimate.dpp = this.formatNumber(this.estimate.dpp,2);
                // 【总费用显示】
                this.estimate.labTotal = this.formatNumber(this.estimate.labTotal,2);
                this.estimate.matTotal = this.formatNumber(this.estimate.matTotal,2);
                this.estimate.applyTotal = this.formatNumber(this.estimate.applyTotal,2);
                this.estimate.approveTotal = this.formatNumber(this.estimate.approveTotal,2);

                // 【箱体/冷机信息】
                let estBodyMachineApprs = estimateInfo.estBodyMachineApprs;
                estBodyMachineApprs.forEach((item)=>{
                    if(item.bodyMachineType == 1){
                        this.tableEstMachines.push(item);//冷机
                    }else{
                        this.tableEstBodys.push(item);//箱体
                    }
                });
                //【箱图片信息】
                let containerPictures = estimateInfo.estContainerPictures;
                containerPictures.forEach((picItem)=>{
                    if(picItem.isRepairCompleted == null || !picItem.isRepairCompleted){
                        // 箱损图片
                        this.tableEstContainerPicInfo.push(picItem)
                    }else{
                        // 修妥图片
                        this.tableEstCompleteContainerPicInfo.push(picItem);
                    }
                });
            },
            /**
             * 箱图片表格筛选功能
             * @param value
             * @param row
             * @returns {boolean}
             */
            filterTag(value, row) {
                // 已添加进删除列表的图片不显示
                let isDelete = false;
                this.deleteEstContainerPictures.forEach((item)=>{
                    if(item.estContainerPictureId != null && item.estContainerPictureId == row.estContainerPictureId){
                        isDelete = true;
                    }else if (item.fileName === row.fileName){
                        isDelete = true;
                    }
                });
                return !isDelete && row.isRepairCompleted === value;
            },
            filterHandler(value, row, column) {
                const property = column['property'];
                return row[property] === value;
            },
            /**********************************************箱损图片上传***********************************************/
            damagePicturesUpload(){
                this.containerDamagePictureUploadShow = true;
            },
            /**
             * 上传文件
             */
            uploadDamageFiles(){
                // 清空带上传文件表单数据
                this.fileImport = new FormData();
                this.$refs.containerDamagePictureUpload.submit();

                if(!this.uploadValidate){
                    return;
                }

                // 校验估价单是否已保存
                if(this.estimate.estimateId != null && this.estimate.estimateId !== ""){
                    this.fileImport.append('estimateId',this.estimate.estimateId);
                }else{
                    this.showMessage(false, this.$t('estimateDetails.saveEstimateFirst'), "warning");
                    return;
                }

                // 上传确认
                this.$confirm(this.$t("common.uploadConfirm"), this.$t("common.pleaseConfirm"), {
                    distinguishCancelAndClose: true,
                    confirmButtonText: this.$t("common.confirmButton"),
                    cancelButtonText: this.$t("common.cancelButton")
                }).then(() => {
                    // 当fileImport中有获取到待上传文件时才发出请求
                    if(!!this.fileImport.entries().next().value) {
                        // 启动进度条
                        this.loadingOverLay = this.$loading({
                            lock: false,
                            text: this.$t('estimate.uploading'),
                            spinner: 'el-icon-loading',
                            background: 'rgba(0,0,0,0.1)'
                        });
                        this.axios.post('/api/equipment/damagePictureUpload', this.fileImport, {
                            headers: {'Content-Type': 'multipart/form-data','Accept-language': localStorage.getItem("locale")},
                            onUploadProgress: (progressEvent)=>{
                                this.percent = Number(
                                    ((progressEvent.loaded / progressEvent.total)*100).toFixed(0)
                                )
                            },
                            timeout: 200000,
                        }).then(response => {
                            this.responseCode = response.data.backMessage;
                            if (response.data.backCode === "200") {
                                // 上传成功关闭上传弹框
                                this.containerDamagePictureUploadShow = false;
                                // 刷新页面数据
                                this.setFieldValue(response.data.object);
                                this.showMessage(false, this.$t('common.uploadSucceed'), "success");
                            } else {
                                this.$alert(this.responseCode.replaceAll(';',' <br/> '), this.$t('estimate.uploadCompleted'), {
                                    customClass: 'uploadMsg',
                                    confirmButtonText: this.$t('common.okButton'),
                                    dangerouslyUseHTMLString: true
                                });
                            }
                            this.loadingOverLay.close();
                        }).catch(error => {
                            if (error.data) {
                                this.responseCode = error.data.backMessage;
                                this.$alert(this.responseCode.replaceAll(';',' <br/> '), this.$t('estimate.uploadCompleted'), {
                                    customClass: 'uploadMsg',
                                    confirmButtonText: this.$t('common.okButton'),
                                    dangerouslyUseHTMLString: true
                                });
                            } else {
                                this.showMessage(false, error, "error");
                            }
                            this.loadingOverLay.close();
                        });
                        // 上传完毕，清空文件存储列表
                        this.fileImport = new FormData();
                    }else{
                        this.showMessage(false, this.$t('estimate.pleaseSelectFiles2Upload'), "warning");
                    }
                })
            },
            /**
             * 自定义箱损图片上传实现
             */
            handleDamgePictureUpload(param){
                // 校验文件格式
                let reg = /(?<=\.)[a-zA-Z]+$/g;
                let fileType = param.file.name.match(reg)+"";
                let typeArr = ["jpg","jpeg","png","bmp","gif","JPG","JPEG","PNG","BMP","GIF"];
                if(!typeArr.includes(fileType)){
                    this.$message.warning(this.$t('estimateDetails.estContainerPic.wrongPicFormat'));
                    this.uploadValidate = false;
                    return;
                }

                // 校验文件大小
                let fileSize = this.formatNumber(param.file.size / 1024 / 1024, 2);
                const isLt20M = fileSize < 5;
                if(!isLt20M){
                    this.$message.warning(this.$t('estimateDetails.estContainerPic.uploadSizeLimit',{fileName: param.file.name, fileSize : (fileSize+'M')}));
                    this.uploadValidate = false;
                    return;
                }

                this.fileImport.append('file',param.file);
            },
            /**
             * 清空已上传文件
             */
            resetFileList(){
                this.fileList = [];
            },
            /*
             *上传成功-回调函数
             */
            uploadSuccess(res, file, fileList){
                // 清除上传文件列表
                this.$refs.containerDamagePictureUpload.clearFiles();
                this.$refs.containerCompletePictureUpload.clearFiles();
            },

            /**********************************************修妥图片上传***********************************************/
            completePicturesUpload(){
                this.containerCompletePictureUploadShow = true;
            },
            /**
             * 上传文件
             */
            uploadCompleteFiles(){
                // 清空带上传文件表单数据
                this.fileImport = new FormData();
                this.$refs.containerCompletePictureUpload.submit();

                if(!this.uploadValidate){
                    return;
                }

                // 校验估价单是否已保存
                if(this.estimate.estimateId != null && this.estimate.estimateId !== ""){
                    this.fileImport.append('estimateId',this.estimate.estimateId);
                }else{
                    this.showMessage(false, "请先保存估价单信息！", "warning");
                    return;
                }

                // 上传确认
                this.$confirm(this.$t("common.uploadConfirm"), this.$t("common.pleaseConfirm"), {
                    distinguishCancelAndClose: true,
                    confirmButtonText: this.$t("common.confirmButton"),
                    cancelButtonText: this.$t("common.cancelButton")
                }).then(() => {
                    // 当fileImport中有获取到待上传文件时才发出请求
                    if(!!this.fileImport.entries().next().value) {
                        // 启动进度条
                        this.loadingOverLay = this.$loading({
                            lock: false,
                            text: this.$t('estimate.uploading'),
                            spinner: 'el-icon-loading',
                            background: 'rgba(0,0,0,0.1)'
                        });
                        this.axios.post('/api/equipment/completePictureUpload', this.fileImport, {
                            headers: {'Content-Type': 'multipart/form-data','Accept-language': localStorage.getItem("locale")},
                            onUploadProgress: (progressEvent)=>{
                                this.percent = Number(
                                    ((progressEvent.loaded / progressEvent.total)*100).toFixed(0)
                                )
                            },
                            timeout: 200000,
                        }).then(response => {
                            this.responseCode = response.data.backMessage;
                            if (response.data.backCode === "200") {
                                // 上传成功关闭上传弹框
                                this.containerCompletePictureUploadShow = false;
                                // 刷新页面数据
                                this.setFieldValue(response.data.object);
                                this.showMessage(false, this.$t('common.uploadSucceed'), "success");
                            } else {
                                this.$alert(this.responseCode.replaceAll(';',' <br/> '), this.$t('estimate.uploadCompleted'), {
                                    customClass: 'uploadMsg',
                                    confirmButtonText: this.$t('common.okButton'),
                                    dangerouslyUseHTMLString: true
                                });
                            }
                            this.loadingOverLay.close();
                        }).catch(error => {
                            if (error.data) {
                                this.responseCode = error.data.backMessage;
                                this.$alert(this.responseCode.replaceAll(';',' <br/> '), this.$t('estimate.uploadCompleted'), {
                                    customClass: 'uploadMsg',
                                    confirmButtonText: this.$t('common.okButton'),
                                    dangerouslyUseHTMLString: true
                                });
                            } else {
                                this.showMessage(false, error, "error");
                            }
                            this.loadingOverLay.close();
                        });
                        // 上传完毕，清空文件存储列表
                        this.fileImport = new FormData();
                    }else{
                        this.showMessage(false, this.$t('estimate.pleaseSelectFiles2Upload'), "warning");
                    }
                })
            },
            /**
             * 自定义修妥图片上传实现
             */
            handleCompletePictureUpload(param){
                // 校验文件格式
                let reg = /(?<=\.)[a-zA-Z]+$/g;
                let fileType = param.file.name.match(reg)+"";
                let typeArr = ["jpg","jpeg","png","bmp","gif","JPG","JPEG","PNG","BMP","GIF"];
                if(!typeArr.includes(fileType)){
                    this.$message.warning(this.$t('estimateDetails.estContainerPic.wrongPicFormat'));
                    this.uploadValidate = false;
                    return;
                }

                // 校验文件大小
                let fileSize = this.formatNumber(param.file.size / 1024 / 1024, 2);
                const isLt20M = fileSize < 5;
                if(!isLt20M){
                    this.$message.warning(this.$t('estimateDetails.estContainerPic.uploadSizeLimit',{fileName: param.file.name, fileSize : (fileSize+'M')}));
                    this.uploadValidate = false;
                    return;
                }

                this.fileImport.append('file',param.file);
            },
            /**
             * 箱损图片行删除功能
             * @param index
             * @param row
             */
            handleDamagePicDelete(index, row) {
                this.$confirm(this.$t("estimateDetails.estContainerPic.deletePicConfirm",{fileName:row.fileName}), this.$t("common.pleaseConfirm"), {
                    distinguishCancelAndClose: true,
                    confirmButtonText: this.$t("common.deleteButton"),
                    cancelButtonText: this.$t("common.cancelButton")
                }).then(() => {
                    this.tableEstContainerPicInfo.forEach((item,pIndex)=>{
                        if(row.estContainerPictureId == null || row.estContainerPictureId === ""){
                            //新增的箱损图片，比对文件名，文件名相同的直接在表格中移除
                            if(row.fileName === item.fileName){
                                this.tableEstContainerPicInfo.splice(pIndex, 1);
                            }
                        }else{
                            //若非新增箱图片记录，则将该条记录加入到待删除修箱图片记录数组中
                            if(item.estContainerPictureId != null
                                && item.estContainerPictureId !== ""
                                && row.estContainerPictureId === item.estContainerPictureId){
                                this.deleteEstContainerPictures.push(this.tableEstContainerPicInfo[pIndex]);
                                this.tableEstContainerPicInfo.splice(pIndex, 1);
                            }
                        }
                    });
                })
            },
            /**
             * 箱损图片批量删除功能
             * @param index
             * @param row
             */
            handleDamagePicBatchDelete() {
                if(this.tableEstContainerPicChecked.length <= 0){
                    this.showMessage(false, this.$t('message.pleaseSelect2operate'), "warning");
                    return;
                }
                this.$confirm(this.$t("estimateDetails.estContainerPic.deleteConfirm"), this.$t("common.pleaseConfirm"), {
                    distinguishCancelAndClose: true,
                    confirmButtonText: this.$t("common.deleteButton"),
                    cancelButtonText: this.$t("common.cancelButton")
                }).then(() => {
                    //删除
                    this.tableEstContainerPicChecked.forEach((checkedItem)=>{
                        this.tableEstContainerPicInfo.forEach((item,index)=>{
                            if(checkedItem.estContainerPictureId == null || checkedItem.estContainerPictureId === ""){
                                //新增的箱损图片，比对文件名，文件名相同的直接在表格中移除
                                if(checkedItem.fileName === item.fileName){
                                    this.tableEstContainerPicInfo.splice(index, 1);
                                }
                            }else{
                                //若非新增箱图片记录，则将该条记录加入到待删除修箱图片记录数组中
                                if(item.estContainerPictureId != null
                                    && item.estContainerPictureId !== ""
                                    && checkedItem.estContainerPictureId === item.estContainerPictureId){
                                    this.deleteEstContainerPictures.push(this.tableEstContainerPicInfo[index]);
                                    this.tableEstContainerPicInfo.splice(index, 1);
                                }
                            }
                        })
                    });
                })
            },
            /**
             * 修妥图片行删除功能
             * @param index
             * @param row
             */
            handleCompletePicBatchDelete() {
                if(this.tableEstCompleteContainerPicChecked.length <= 0){
                    this.showMessage(false, this.$t('message.pleaseSelect2operate'), "warning");
                    return;
                }
                this.$confirm(this.$t("estimateDetails.estContainerPic.deleteConfirm"), this.$t("common.pleaseConfirm"), {
                    distinguishCancelAndClose: true,
                    confirmButtonText: this.$t("common.deleteButton"),
                    cancelButtonText: this.$t("common.cancelButton")
                }).then(() => {
                    //删除
                    this.tableEstCompleteContainerPicChecked.forEach((checkedItem)=>{
                        this.tableEstCompleteContainerPicInfo.forEach((item,index)=>{
                            if(checkedItem.estContainerPictureId == null || checkedItem.estContainerPictureId === ""){
                                //新增的箱损图片，比对文件名，文件名相同的直接在表格中移除
                                if(checkedItem.fileName === item.fileName){
                                    this.tableEstCompleteContainerPicInfo.splice(index, 1);
                                }
                            }else{
                                //若非新增箱图片记录，则将该条记录加入到待删除修箱图片记录数组中
                                if(item.estContainerPictureId != null
                                    && item.estContainerPictureId !== ""
                                    && checkedItem.estContainerPictureId === item.estContainerPictureId){
                                    this.deleteEstContainerPictures.push(this.tableEstCompleteContainerPicInfo[index]);
                                    this.tableEstCompleteContainerPicInfo.splice(index, 1);
                                }
                            }
                        })
                    });
                })
            },


            initCombos() {
            },
            /**
             * 【返回】按钮点击
             */
            returnPage() {
                // this.$router.back(-1)
                window.opener = null;
                window.open("about:blank", "_top").close()
            },
        },
        mounted() {
        },
        created() {
            this.initCombos();
            this.initPageInfo();
            this.$parent.updateHeaderAside();
        }
    }
</script>
<style lang="scss" scoped>
    @import "../../../assets/scss/base.scss";
    @import "../../../assets/scss/public.scss";

    .el-row {
        margin-bottom: 0;

        &:last-child {
            margin-bottom: 0;
        }
    }

    .el-col {
        margin-bottom: 0;
        border-radius: 4px;
    }

    .inputName-left {
        flex: 1;
        margin: 0 5px;
    }

    .packageTypeButton {
        width: 25px;
        height: 25px;
        margin-top: 2px;
    }

    .cardBox {
        background: $colorA;
        margin-bottom: 20px;
        border: 1px solid #e8e8e8;
        box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.05);
        border-radius: 3px;
        padding: 16px 16px 1px 16px;
    }

    .lastCardBox {
        width: 59.5%;
        margin-right: 0.5%;
        height: 80px;
    }

    .lastCardBox2 {
        width: 59.5%;
        height: 80px;
    }

    .cardTitle {
        margin-bottom: 10px;

        span {
            font-size: $fontE;
            color: rgba(0, 0, 0, 0.85);
            letter-spacing: 0;
            font-weight: 600;
            margin-left: 6px;
        }
    }

    .cardTitle2 {
        margin-top: 10px;

        span {
            font-size: $fontE;
            color: rgba(0, 0, 0, 0.85);
            letter-spacing: 0;
            font-weight: 600;
            margin-left: 6px;
        }
    }

    .collapseTitle {
        margin-bottom: 10px;

        span {
            font-size: $fontE;
            color: rgba(0, 0, 0, 0.85);
            letter-spacing: 0;
            font-weight: 600;
            margin-left: 6px;
        }
    }

    .collapseItem {
        margin-top: -16px;
    }

    .setting {
        justify-content: flex-start;

        ul {
            li {
                margin-right: 15px;
                color: #6d7278;
                font-size: $fontB;
            }
        }
    }

    .show_table {
        position: relative;
        width: 100%;
        overflow: auto;
    }

    /*给el-table滚动条设置宽度和高度*/
    /deep/ .el-table__body-wrapper::-webkit-scrollbar {
        width: 10px; // 横向滚动条
        height: 10px; // 纵向滚动条 必写
    }

    .position-right {
        height: 20px;
        text-align: right;
    }

    .topMargin {
        margin-top: 20px;
    }

    .popoverInner {
        margin: 5px;
        margin-top: 0;
    }

    .inputName-title-left-textarea3 {
        height: 52px;
        line-height: 53px;
    }

    /deep/ .el-collapse-item__header {
        padding: 16px 16px 1px 16px;
    }

    /deep/ .el-collapse-item__content {
        padding: 16px 16px 1px 16px;
    }

    /deep/ .el-icon-arrow-right {
        border-radius: 50%;
        border: 2px solid #e8e8e8;
        color: #2867ce;
        font-size: $fontE;
        font-weight: 600;
    }

    .el-image.el-image__error {
         display: flex;
         justify-content: center;
         align-items: center;
         font-size: 14px;
         background: #F5F7FA;
         color: #C0C4CC;
         vertical-align: middle;
     }

    .my-upload-demo ::v-deep .el-upload {
        .el-upload-dragger {
            background-color: #fff;
            border: 1px dashed #d9d9d9;
            border-radius: 6px;
            box-sizing: border-box;
            width: 800px;
            height: 180px;
            text-align: center;
            cursor: pointer;
            position: relative;
            overflow: hidden;
        }
    }

    .inputName {
        flex: 1;
        margin: 2px 5px;
    }

    //重写el-input样式，只显示下边框
    .inputName ::v-deep.el-input__inner{
        border-radius: 0;// 去掉圆角
        border-left-width: 0;
        border-right-width: 0;
        border-top-width: 0;
        border-bottom-width: 1px;//只显示下边框
    }

    //重写disabled样式，背景色调整为白色
    .inputName ::v-deep.el-input.is-disabled .el-input__inner {
        background-color: #FFFFFF;
        border-color: #E4E7ED;
        color: black;
        cursor: not-allowed;
    }
</style>